import { render, staticRenderFns } from "./AssetPage.vue?vue&type=template&id=02c1fbc7"
import script from "./AssetPage.vue?vue&type=script&lang=js"
export * from "./AssetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports